/* Escaneador. Calcula os níveis a partir do próprio histograma da foto,
   clareia o papel e escurece o texto. Não usa biblioteca externa. */
import { esc, limpaNome, carregarImg, lerURL } from "../util.js";

/* ---------- escaneador: realca o documento e reduz o peso ---------- */
export function filtroDocumento(cv){
  const ctx=cv.getContext("2d"), d=ctx.getImageData(0,0,cv.width,cv.height), px=d.data;
  const hist=new Uint32Array(256);
  for(let i=0;i<px.length;i+=4){
    const v=(px[i]*.299+px[i+1]*.587+px[i+2]*.114)|0;
    px[i]=px[i+1]=px[i+2]=v; hist[v]++;
  }
  // niveis automaticos: acha o preto do texto e o branco do papel
  const total=cv.width*cv.height;
  let soma=0,pb=0,pw=255;
  for(let v=0;v<256;v++){ soma+=hist[v]; if(soma>total*0.04){ pb=v; break; } }
  soma=0;
  for(let v=255;v>=0;v--){ soma+=hist[v]; if(soma>total*0.22){ pw=v; break; } }
  if(pw-pb<40){ pb=Math.max(0,pw-60); }
  const faixa=Math.max(1,pw-pb);
  const lut=new Uint8Array(256);
  for(let v=0;v<256;v++){
    let t=(v-pb)/faixa;
    t=t<0?0:t>1?1:t;
    t=t*t*(3-2*t);            // curva suave: escurece texto, limpa o fundo
    lut[v]=Math.round(t*255);
  }
  for(let i=0;i<px.length;i+=4){ const v=lut[px[i]]; px[i]=px[i+1]=px[i+2]=v; }
  ctx.putImageData(d,0,0);
}
export async function escanearArquivo(f,modoDoc){
  const img=await carregarImg(await lerURL(f));
  const max=2000, k=Math.min(1,max/Math.max(img.width,img.height));
  const cv=document.createElement("canvas");
  cv.width=Math.round(img.width*k); cv.height=Math.round(img.height*k);
  cv.getContext("2d").drawImage(img,0,0,cv.width,cv.height);
  if(modoDoc) filtroDocumento(cv);
  return cv;
}
export function girar(cv){
  const n=document.createElement("canvas");
  n.width=cv.height; n.height=cv.width;
  const c=n.getContext("2d");
  c.translate(n.width/2,n.height/2); c.rotate(Math.PI/2);
  c.drawImage(cv,-cv.width/2,-cv.height/2);
  return n;
}
/* tela de conferencia depois de fotografar */
export function abrirEscaner(file,rotulo){
  return new Promise(async resolve=>{
    let modoDoc=true, cv=await escanearArquivo(file,true);
    const el=document.createElement("div"); el.className="scan";
    el.innerHTML=`<div class="scan-bar"><span class="nm">${esc(rotulo)}</span><button class="mini" data-x>Cancelar</button></div>
      <div class="scan-body"><img id="scanImg" alt=""></div>
      <div class="scan-pe">
        <button class="btn ghost" data-modo>Cor original</button>
        <button class="btn ghost" data-girar>Girar</button>
        <button class="btn" data-ok>Usar este</button>
      </div>`;
    document.body.appendChild(el);
    const pintar=()=>{ el.querySelector("#scanImg").src=cv.toDataURL("image/jpeg",.8); };
    pintar();
    el.querySelector("[data-modo]").onclick=async e=>{
      modoDoc=!modoDoc;
      e.currentTarget.textContent=modoDoc?"Cor original":"Modo documento";
      const ang=cv.width>cv.height!==null; // preserva orientacao atual
      cv=await escanearArquivo(file,modoDoc); pintar();
    };
    el.querySelector("[data-girar]").onclick=()=>{ cv=girar(cv); pintar(); };
    el.querySelector("[data-x]").onclick=()=>{ el.remove(); resolve(null); };
    el.querySelector("[data-ok]").onclick=()=>{
      cv.toBlob(b=>{
        el.remove();
        resolve({blob:b,nome:limpaNome(rotulo)+".jpg",tipo:"image/jpeg",preview:cv.toDataURL("image/jpeg",.35)});
      },"image/jpeg",.82);
    };
  });
}
